import { useState } from "react";
import { Link } from "react-router-dom";

const footerLinks = [
  { label: "品牌故事", href: "/about" },
  { label: "商品分類", href: "/shop" },
  { label: "穿搭提案", href: "/lookbook" },
  { label: "最新消息", href: "/news" },
  { label: "部落格", href: "/blog" },
  { label: "常見問題", href: "/faq" },
  { label: "門市資訊", href: "/contact" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
    }
  };

  return (
    <footer className="bg-[#3d2b1f] text-[#f5e8d8] mt-0">
      <div className="w-full px-8 md:px-16 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand Info */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/63b8b7b1f5a3fb4c3a27d835417dcfba.png"
              alt="品牌Logo"
              className="h-10 w-auto object-contain mb-4 brightness-200 opacity-90"
            />
            <p className="text-[1.0625rem] text-[#c9a98a] leading-relaxed mb-5">
              台中女性服飾 Outlet 門市<br />
              台灣設計師 30 年暢銷品牌<br />
              質感女裝，輕奢好價格
            </p>
            <div className="flex items-center gap-3">
              <a href="https://line.me" target="_blank" rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#c9a98a]/20 hover:bg-[#c9a98a]/40 transition-colors cursor-pointer">
                <i className="ri-line-fill text-[#c9a98a]"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#c9a98a]/20 hover:bg-[#c9a98a]/40 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-[#c9a98a]"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#c9a98a]/20 hover:bg-[#c9a98a]/40 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-[#c9a98a]"></i>
              </a>
            </div>
          </div>

          {/* Nav Links */}
          <div>
            <h4 className="text-[1.0625rem] font-semibold text-[#f5e8d8] mb-5 tracking-wider uppercase">
              <a href="#nav">網站導覽</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-[1rem] text-[#c9a98a] hover:text-[#f5e8d8] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Store Info */}
          <div>
            <h4 className="text-[1.0625rem] font-semibold text-[#f5e8d8] mb-5 tracking-wider uppercase">
              <a href="#store-info">門市資訊</a>
            </h4>
            <ul className="flex flex-col gap-3 text-[1rem] text-[#c9a98a]">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
                <span>台中市西屯區台灣大道三段XXX號</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line flex-shrink-0"></i>
                <a href="tel:+886-4-XXXX-XXXX" rel="nofollow" className="hover:text-[#f5e8d8] transition-colors">04-XXXX-XXXX</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 flex-shrink-0"></i>
                <span>週二至週日 11:00–19:30<br />週一公休</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-line-fill flex-shrink-0"></i>
                <a href="https://line.me" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#f5e8d8] transition-colors">LINE 線上諮詢</a>
              </li>
            </ul>
          </div>

          {/* Subscribe */}
          <div>
            <h4 className="text-[1.0625rem] font-semibold text-[#f5e8d8] mb-3 tracking-wider uppercase">
              <a href="#subscribe">訂閱新品通知</a>
            </h4>
            <p className="text-[1rem] text-[#c9a98a] mb-5 leading-relaxed">
              第一時間收到新品上架、<br />限量優惠與穿搭建議
            </p>
            {subscribed ? (
              <p className="text-[#c9a98a] text-[1rem] font-medium">感謝訂閱！我們將為您送上最新消息。</p>
            ) : (
              <form onSubmit={handleSubscribe} className="flex items-center gap-0" id="footer-subscribe">
                <input
                  type="email"
                  name="email"
                  placeholder="輸入您的電子信箱"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-[#5a3e31] text-[#f5e8d8] placeholder-[#a07b65] px-4 py-3 rounded-l-full text-[1rem] outline-none focus:bg-[#6a4e3d] transition-colors"
                  required
                />
                <button
                  type="submit"
                  className="w-12 h-12 bg-[#c9a98a] rounded-full flex items-center justify-center hover:bg-[#b8957a] transition-colors cursor-pointer flex-shrink-0 whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line text-[#3d2b1f] text-lg"></i>
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Brand Watermark */}
        <div className="border-t border-[#5a3e31] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[1rem] text-[#7a5a48]">
            © 2024 台中女性服飾 Outlet. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[1rem] text-[#7a5a48]">
            <a href="/faq" rel="nofollow" className="hover:text-[#c9a98a] transition-colors cursor-pointer">隱私政策</a>
            <span>·</span>
            <a href="/contact" rel="nofollow" className="hover:text-[#c9a98a] transition-colors cursor-pointer">聯絡我們</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
